import { CSSProperties } from "react";

import { useTheme, useWindowDimensions } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const { width } = useWindowDimensions();
  const isSmallScreen = width <= 1150;
  const isMobile = width <= 600;

  const styles: Record<string, CSSProperties> = {
    container: {
      marginLeft: spacing.m,
      marginRight: spacing.m,
      padding: spacing.xs,
      backgroundColor: theme.verification.banner.home.inProgress,
      borderRadius: constants.radius.view,
      marginBottom: isMobile ? spacing.xs : spacing.m,
      width: isMobile ? 350 : undefined,
      maxWidth: isMobile ? 350 : undefined,
      justifySelf: isMobile ? "center" : undefined,
    },
    content: {
      display: "flex",
      flexDirection: isSmallScreen ? "column" : "row",
      alignItems: isSmallScreen ? "flex-start" : "center",
      gap: isSmallScreen ? spacing.xs : 0,
    },
    title: {
      marginLeft: spacing.xs,
      fontWeight: 700,
    },
    subtitle: {
      marginLeft: spacing.xs,
    },
    contactSupport: {
      marginLeft: spacing.xs,
      textDecoration: "underline",
      fontWeight: 700,
    },
    contactSupportContainer: {
      userSelect: "none",
      cursor: "pointer",
    },
  };

  return styles;
};
